import { forwardRef, ReactNode } from "react";
import {
  CheckboxButton,
  CheckboxField,
  CheckboxFieldProps,
} from "react-aria-components";
import styles from "./Checkbox.module.css";

export interface MyCheckboxProps extends CheckboxFieldProps {
  children?: ReactNode;
}

const Checkbox = forwardRef<HTMLDivElement, MyCheckboxProps>(
  ({ children, ...props }, ref) => (
    <CheckboxField ref={ref} {...props}>
      <CheckboxButton className={styles.checkboxContainer}>
        <span className={styles.checkboxIcon}></span>
        {children}
      </CheckboxButton>
    </CheckboxField>
  ),
);

export default Checkbox;
